import React from 'react'
import PhotoAlbum from "react-photo-album";

// https://react-photo-album.com/examples/rows
const photos = [
    { src: "/images/img-1.jpg", width: 800, height: 600 },
    { src: "/images/img-2.jpg", width: 1600, height: 900 },
    { src: "/images/img-3.jpg", width: 1600, height: 900 },
    { src: "/images/img-4.jpg", width: 1600, height: 900 },
    { src: "/images/img-5.jpg", width: 1600, height: 900 },
    { src: "/images/img-6.jpg", width: 1600, height: 900 },
    { src: "/images/img-7.jpg", width: 1600, height: 900 },
    { src: "/images/img-8.jpg", width: 1600, height: 900 },
    { src: "/images/img-9.jpg", width: 1600, height: 900 },
    { src: "/images/img-home.jpg", width: 1600, height: 900 },
    { src: "/images/linga2_compressed.jpeg", width: 1600, height: 900 },
    { src: "/images/linga3_Compressed.jpeg", width: 1600, height: 900 },
    { src: "/images/mandir1.jpeg", width: 1600, height: 900 },
    { src: "/images/mandir2.jpeg", width: 1600, height: 900 },
    { src: "/images/mandir3.jpeg", width: 1600, height: 900 },
    { src: "/images/mandir4.jpg", width: 1600, height: 900 },
  ];
  
export default function Portfolio() {
    return <PhotoAlbum layout="masonry" photos={photos} />;
}

